/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayType } from './PayType';
import {
    PayTypeFromJSON,
    PayTypeFromJSONTyped,
    PayTypeToJSON,
    PayTypeToJSONTyped,
} from './PayType';

/**
 * 
 * @export
 * @interface UpdatePayTypeResponse
 */
export interface UpdatePayTypeResponse {
    /**
     * 
     * @type {PayType}
     * @memberof UpdatePayTypeResponse
     */
    data: PayType;
}

/**
 * Check if a given object implements the UpdatePayTypeResponse interface.
 */
export function instanceOfUpdatePayTypeResponse(value: object): value is UpdatePayTypeResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdatePayTypeResponseFromJSON(json: any): UpdatePayTypeResponse {
    return UpdatePayTypeResponseFromJSONTyped(json, false);
}

export function UpdatePayTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePayTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PayTypeFromJSON(json['data']),
    };
}

  export function UpdatePayTypeResponseToJSON(json: any): UpdatePayTypeResponse {
      return UpdatePayTypeResponseToJSONTyped(json, false);
  }

  export function UpdatePayTypeResponseToJSONTyped(value?: UpdatePayTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PayTypeToJSON(value['data']),
    };
}

